import { useRef } from 'react';
import { v4 as uuidv4 } from 'uuid';

export default function useId(prefix = 'element') {
  return useRef(`${prefix}-${uuidv4()}`).current;
}
